export default function HighlightFeaturesCards({ data, classes }) {
  const { heading, list } = data;
  const List = () => {
    let theClasses;
    let theCount = list.length;
    if (theCount === 3) {
      theClasses = "has-three-col";
    }
    if (theCount === 4) {
      theClasses = "has-four-col";
    }

    return (
      <div
        className={`container card--default card--feature lg:mt-10 ${theClasses}`}
      >
        {list.map((item, count) => {
          return item.isExternal ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline md:mb-0 md:mt-5 md:pb-3 md:pl-2.5 md:pr-2 md:pt-2.5 pb-4 pl-3 pr-2 pt-3 text-left bg:hover-white"
              href={item.href}
              key={count}
            >
              <h3 className="lg:mb-3 text-brandcolor">{item.heading}</h3>
              <p
                className="md:mt-1.5"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </a>
          ) : (
            <a
              className="btn-outline md:mb-0 md:mt-5 md:pb-3 md:pl-2.5 md:pr-2 md:pt-2.5 pb-4 pl-3 pr-2 pt-3 text-left bg:hover-white"
              href={item.href}
              key={count}
            >
              <h3 className="lg:mb-3 text-brandcolor">{item.heading}</h3>
              <p
                className="md:mt-1.5"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </a>
          );
        })}
      </div>
    );
  };
  return (
    <section
      className={`bg-light lg:pt-20 lg:pb-15 md:pt-10 md:pb-10 features ${classes}`}
    >
      <article className="container lg:maxw-xl block--align-center lg:text-center md:text-left">
        <h2
          className="text-xl md:pr-1"
          dangerouslySetInnerHTML={{ __html: heading }}
        ></h2>
        {data.hasOwnProperty("desc") && (
          <p
            className="lg:mb-4 md:m-0 lg:maxw-lg lg:ml-auto lg:mr-auto"
            dangerouslySetInnerHTML={{ __html: data.desc }}
          ></p>
        )}
      </article>
      <div>
        <List />
      </div>
    </section>
  );
}
